import React, { FC, useState } from 'react';
import { Link } from 'react-router-dom';

import { AuthInfo, LoginFormData } from 'types';
import ROUTES from 'constants/routes';
import { useAppDispatch } from 'store';
import { loginAction, setAuthInfo } from 'store/auth/auth.reducer';
import { PhoneConfirmation } from 'containers/PhoneConfirmation/PhoneConfirmation';
import AuthEntryLayout from 'layouts/AuthEntryLayout/AuthEntryLayout';
import { LoginForm } from './components/LoginForm/LoginForm';
import styles from 'layouts/AuthEntryLayout/AuthEntryLayout.module.scss';

const LoginPage: FC = () => {
  const dispatch = useAppDispatch();
  const [confirmToken, setConfirmToken] = useState<string>('');
  const [rememberMe, setRememberMe] = useState<boolean>();

  const handleSubmit = async ({ phone, password, rememberMe }: LoginFormData) => {
    const { token } = await dispatch(loginAction({ phone, password }));
    setConfirmToken(token);
    setRememberMe(rememberMe);
  };

  const handlePhoneVerified = ({ token }: AuthInfo) => {
    dispatch(setAuthInfo({ data: { token }, rememberMe }));
  };

  return (
    <AuthEntryLayout title="Вход в личный кабинет">
            {confirmToken ? (
              <>
                <PhoneConfirmation
                  type={ROUTES.LOGIN}
                  confirmToken={confirmToken}
                  onFinish={handlePhoneVerified}
                  onResend={setConfirmToken}
                  appearance="login"
                />
                <button className={styles.back} type="button" onClick={() => setConfirmToken('')}>
                  ← Вернуться
                </button>
              </>
            ) : (
              <>
                <LoginForm onSubmit={handleSubmit} />
                <div className={styles.forgotPassword}>
                  <Link to={ROUTES.PASSWORD_RECOVERY}>Не помню пароль</Link>
                </div>
              </>
            )}
    </AuthEntryLayout>
  );
};

export default LoginPage;
